// extracted by mini-css-extract-plugin
export default {"wlarge":"Guests_wlarge__uRDb5","wsmall":"Guests_wsmall__SvB4A","capitalize":"Guests_capitalize__IJQaj","stripe":"Guests_stripe__NBIz9"};